module.exports = {"heading":"","images":["Slideshow_01.jpg","Slideshow_02.jpg","Slideshow_03.jpg","Slideshow_06.jpg","Slideshow_07.jpg","Slideshow_08.jpg","Slideshow_09.jpg"],"images_mobile":["slideshow_01_mobile.jpg","slideshow_02_mobile.jpg","slideshow_03_mobile.jpg","slideshow_06_mobile.jpg","slideshow_07_mobile.jpg","slideshow_08_mobile.jpg","slideshow_09_mobile.jpg"]}


//////////////////
// WEBPACK FOOTER
// ./public/content/sections/impressions.json
// module id = 914
// module chunks = 0